<div class="dialog">
  <div class="dialog__title" *ngIf="message">{{message}}</div>
  <div class="dialog__title" *ngIf="messageHTML" [innerHTML]="html(messageHTML)"></div>
  <div class="dialog__action row">
    <button class="text-button flat" mat-button (click)="close()" translate>general.cancel</button>
    <button class="text-button" [class.bg-error]="destructive" [class.bg-success]="!destructive" mat-button
      [mat-dialog-close]="true" translate>general.confirm</button>
  </div>
</div>
